import { Route } from 'react-router-dom';
import { CreateLoanPage } from './create-loan';
import { EditLoanPage } from './edit-loan';
import { ListLoansPage } from './list-loans';
import { ViewLoanPage } from './view-loan';
import { RequireAuth } from '/src/components';

export { CreateLoanPage, EditLoanPage, ListLoansPage, ViewLoanPage };

export const loansRoutes: React.ReactElement[] = [
  <Route
    path="/deals/create"
    element={
      <RequireAuth>
        <CreateLoanPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/deals/:loanId/edit"
    element={
      <RequireAuth>
        <EditLoanPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/deals"
    element={
      <RequireAuth>
        <ListLoansPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/deals/:loanId"
    element={
      <RequireAuth>
        <ViewLoanPage />
      </RequireAuth>
    }
  />,
];
